import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { SelectedLocation } from '../models/selectedLocation.interface';



/**
 * SelectedLocationService manages the user's selected location.
 * It provides a BehaviorSubject to get and set the current location,
 * including whether laydown space is available at that location.
 */

@Injectable({
  providedIn: 'root',
})
export class SelectedLocationService {
  private _selectedLocation = new BehaviorSubject<SelectedLocation>({ 
    name: 'norfolk', 
    label: 'Norfolk',
    laydownSpaceAvailable: false 
  });

  /**
   * Observable for the selected location.
   */
  public selectedLocation$ = this._selectedLocation.asObservable();

  /**
   * Get the current selected location value.
   */
  public getSelectedLocation(): SelectedLocation {
    return this._selectedLocation.value;
  }

  /**
   * Set a new selected location.
   * @param location The new location to set.
   */
  public setSelectedLocation(location: SelectedLocation): void {
    this._selectedLocation.next(location);
  }

  /**
   * Check if the current selected location has laydown space available.
   * @returns true if laydown space is available at the current location, false otherwise
   */
  public isLaydownAvailableAtCurrentLocation(): boolean {
    return this._selectedLocation.value.laydownSpaceAvailable;
  }
}
